import React from 'react'
import PropTypes from 'prop-types'
import posed from 'react-pose'
import { ReactComponent as ReadyToCollectImage } from '../../assets/images/store-building.svg'
import { ReactComponent as MarkerImage } from '../../assets/images/store-marker.svg'
import { ReactComponent as CarImage } from '../../assets/images/car-only.svg'
import { ReactComponent as ErrorImage } from '../../assets/images/major-error-404.svg'
import { ReactComponent as AlreadyCollectedImage } from '../../assets/images/already-collected.svg'

const PosedHorizonDiv = posed.div({
  start: { opacity: 1, x: '100%' },
  end: {
    opacity: 1,
    x: '0%',
    transition: {
      duration: 400,
    },
  },
})

const PosedReadyDiv = posed.div({
  start: { opacity: 1, x: '100%' },
  end: {
    opacity: 1,
    x: '0%',
    transition: {
      delay: 400,
      duration: 400,
      ease: 'easeOut',
    },
  },
})

const PosedManDiv = posed.div({
  start: { opacity: 0, scale: 0 },
  end: {
    opacity: 1,
    scale: 1,
    transition: {
      type: 'spring',
      stiffness: 500,
      damping: 20,
      duration: 600,
    },
  },
})

const PosedPinDiv = posed.div({
  start: { opacity: 1, y: '-100%' },
  end: {
    opacity: 1,
    y: '55%',
    transition: {
      y: {
        type: 'spring',
        stiffness: 800,
        damping: 25,
        delay: 600,
        duration: 500,
      },
    },
  },
  complete: {
    opacity: 1,
    y: '-100%',
    transition: {
      duration: 500,
    },
  },
})

const PosedCarDiv = posed.div({
  start: { opacity: 1, x: '100vw' },
  end: {
    opacity: 1,
    x: '0vw',
    transition: {
      duration: 1000,
      ease: 'easeOut',
    },
  },
})

const propTypes = {
  stage: PropTypes.oneOf([
    'baySelection',
    'arrived',
    'error',
    'alreadyCollected',
  ]),
}

const AnimatedSvg = ({ stage }) => {
  return (
    <>
      {stage === 'error' ? (
        <PosedManDiv key="card-ready" initialPose="start" pose="end">
          <ErrorImage className="mt-6 mx-auto" />
        </PosedManDiv>
      ) : stage === 'alreadyCollected' ? (
        <PosedManDiv key="card-ready" initialPose="start" pose="end">
          <AlreadyCollectedImage className="mt-6 mx-auto" />
        </PosedManDiv>
      ) : (
        <>
          <PosedReadyDiv key="store" initialPose="start" pose="end">
            <ReadyToCollectImage className="mt-6 ml-6" />
          </PosedReadyDiv>
          <PosedHorizonDiv
            className="h-horizon bg-body-dark"
            initialPose="start"
            pose="end"
          ></PosedHorizonDiv>
        </>
      )}
      {(stage === 'baySelection' || stage === 'arrived') && (
        <PosedPinDiv
          className="absolute top-0 left-marker"
          key="card-marker"
          initialPose="start"
          pose={stage === 'arrived' ? 'complete' : 'end'}
        >
          <MarkerImage />
        </PosedPinDiv>
      )}
      {stage === 'arrived' && (
        <PosedCarDiv
          className="absolute bottom-0"
          key="card-car"
          initialPose="start"
          pose="end"
        >
          <CarImage />
        </PosedCarDiv>
      )}
    </>
  )
}

AnimatedSvg.propTypes = propTypes

export default AnimatedSvg
